"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledMask = void 0;
var _Mask = require("./Mask");
// TODO: in v9, move styled() from Mask.jsx to here
var StyledMask = _Mask.Mask;
exports.StyledMask = StyledMask;